import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import "../CSS/appointment.css"
import ProgressBarElement from "../Components/ProgressBarElement.js"
import LocationAddModal from "../Components/LocationAddModal.js"
import LocationForm from "../Components/LocationForm.js"
import SelectRSL from "../Components/SelectRSL.js"
import SelectBuildings from "../Components/SelectBuildings.js"
import LocationEdit from "../Components/LocationEdit"
import CirclePlus from '../images/dbplus@3x.png'
import Modal from 'react-modal';
import AppointmentService from '../utils/AppointmentService.js';
import HomeIcon from '../images/home.png'
import WorkIcon from '../images/business.png'
import SpiffyMapIcon from '../images/mapIcon.png'
import { withScriptjs, withGoogleMap, GoogleMap, Marker, OverlayView } from "react-google-maps"

import {
  BrowserRouter as Router,
  Link,
  Route // for later
} from 'react-router-dom'
import ErrorSnackBar from "./ErrorSnackBar";
const { compose, withProps, lifecycle } = require("recompose");
const { InfoBox } = require("react-google-maps/lib/components/addons/InfoBox");
const { SearchBox } = require("react-google-maps/lib/components/places/SearchBox");
const { MarkerWithLabel } = require("react-google-maps/lib/components/addons/MarkerWithLabel");
const _ = require("lodash");
const google = window.google

const MapWithASearchBox = compose(
  withProps({
    googleMapURL: "https://maps.googleapis.com/maps/api/js?key=AIzaSyD2mSKeIWHZpjASwcopmqGaWmkqqEgcf80&v=3.exp&libraries=geometry,drawing,places",
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div id='mapContainer' style={{ height: `92%` }} />,
    mapElement: <div id='map' style={{ height: `97%` }} />,

  }),
  lifecycle({
    componentDidMount() {
      this.state = {
        showAtWork: false
      };
      const refs = {}
      //var currentLocation = {lat: parseFloat(localStorage.getItem('lat')), lng: parseFloat(localStorage.getItem('lng'))}
      this.setState({
        center: {
          lat: parseFloat(localStorage.getItem('lat')), lng: parseFloat(localStorage.getItem('lng')),
        },
        position: {
          lat: parseFloat(localStorage.getItem('lat')), lng: parseFloat(localStorage.getItem('lng')),
        },
        onMapMounted: ref => {
          refs.map = ref;
        },
        onBoundsChanged: _.debounce(
          () => {
          this.setState({
            bounds: refs.map.getBounds(),
            center: refs.map.getCenter(),
            position: refs.map.getCenter()
          })
          let { onBoundsChange } = this.props
          if (onBoundsChange) {
            onBoundsChange(refs.map)
          }
          },
          50,
          { maxWait: 400 }
        ),
        onSearchBoxMounted: ref => {
          refs.searchBox = ref;
        },
        dragMap: ref => {
          var center = {
            lat: refs.map.getCenter().lat(),
            lng: refs.map.getCenter().lng()
          }

          this.setState({
            center: center,
            position: center
          })
        },
        onPlacesChanged: () => {
          const places = refs.searchBox.getPlaces();
          const bounds = new google.maps.LatLngBounds();

          const nextMarkers = places.map(place => ({
            position: place.geometry.location,
          }));
          const nextCenter = _.get(nextMarkers, '0.position', this.state.center);
          this.setState({
            center: nextCenter,
            markers: nextMarkers,
            position: {lat: places[0].geometry.location.lat(), lng: places[0].geometry.location.lng()},
          });
        },
        onClick: ({ count }) => (
                    this.parentThis = this,
                     this.ApptService = new AppointmentService(),
                     this.setState({
                       showForm: false
                     }),
                     this.ApptService.rslBuildings(this.state.center.lat(), this.state.center.lng())
                     .then(res =>{
                           var buildings = []
                           buildings = res.locations
                           var showForm
                           if(buildings && buildings.length < 1){
                             showForm = true
                           }
                           else{
                             showForm = false
                           }
                           this.setState({
                             buildings: res.locations,

                           }, function(){
                             document.getElementById('mapContainer').style.height = '50%'

                           });
                           return this
                           //document.getElementById('map').style.height = '50%'


                     }).then(function(parentThis){
                       parentThis.ApptService.addressFromCoords(parentThis.state.center.lat(), parentThis.state.center.lng())

                       .then(res =>{
                         if(res.results && res.results[0]){
                          if(parentThis.state.buildings && parentThis.state.buildings.length > 0){
                           parentThis.setState({
                             mapAddress: res.results[0].formatted_address,
                             showAtWork: true,
                             showForm: false,
                             thisProps: parentThis.props
                           })
                          }
                          else {
                           parentThis.setState({
                             mapAddress: res.results[0].formatted_address,
                             showAtWork: false,
                             showForm: true,
                             thisProps: parentThis.props
                            })
                          }
                          parentThis.props.onClick(parentThis.state.buildings, parentThis.state.showForm, parentThis.state.showAtWork, parentThis.state.mapAddress)

                         }
                       })
                      .catch(err => {
                        throw new Error('Error fetching addresses: ' + err.message);
                      });
                     })


                 ),
               })
             },
           }),
  withScriptjs,
  withGoogleMap,
)(props =>
  <div>
    <GoogleMap
      ref={props.onMapMounted}
      defaultZoom={15}
      center={props.center}
      onBoundsChanged={props.onBoundsChanged}
      defaultOptions={{
       // these following 7 options turn certain controls off see link below
        mapTypeControl: false,
        fullscreenControl: false
      }}
    >
      <SearchBox
        ref={props.onSearchBoxMounted}
        controlPosition={google.maps.ControlPosition.TOP_LEFT}
        onPlacesChanged={props.onPlacesChanged}
      >
        <input
          type="text"
          placeholder="Search for your address..."
          style={{
            boxSizing: `border-box`,
            border: `1px solid transparent`,
            width: `50%`,
            height: `32px`,
            marginTop: `27px`,
            marginLeft: `25%`,
            padding: `0 12px`,
            borderRadius: `3px`,
            boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
            fontSize: `14px`,
            outline: `none`,
            textOverflow: `ellipses`,
          }}
        />
      </SearchBox>
        <Marker
          position={props.position}
          icon={SpiffyMapIcon}
          >
        </Marker>
        <OverlayView
          position={props.position}
          mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
        >
          <div style={{ background: `white`, border: `1px solid #ccc`, padding: 0 }}>
            <button className="btn" onClick={props.onClick} style={{ color: 'white', backgroundColor: '#5BBA76', width: 80, height: 40 }}>
              Confirm
            </button>
          </div>
        </OverlayView>
    </GoogleMap>
  </div>
);
export class Locations extends Component {
  constructor(props) {
    super(props)
    navigator.geolocation.getCurrentPosition(function(position) {
    });
    this.ApptService = new AppointmentService()
    this.handleChildClick = this.handleChildClick.bind(this)
    this.newLocationClick = this.newLocationClick.bind(this)
    this.reloadAddresses = this.reloadAddresses.bind(this)
    this.setError = this.setError.bind(this)

    this.state = {
      modalIsOpen: false,
      minimumModalOpen: false,
      outOfAreaModalOpen: false,
      travelFeeModalOpen: false,
      addresses:this.props.addresses,
      addressesHTML: [],
      address: null,
      currentLocation: [],
      buildings: [],
      specificBuildings: [],
      showAtWork: false,
      showBuildings: false,
      showForm: false,
      showButton: false,
      mapAddress: [],
      width: document.body.clientWidth,
      open:false,
      errorMessage: '',
      color: '#A43E42'
    };

    const addresses2 = this.state.addresses
    this.onChange = (address) => this.setState({ address })
    this.openModal = this.openModal.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.showForm = this.showForm.bind(this)
    this.saveBuildings = this.saveBuildings.bind(this)
    this.selectAddress = this.selectAddress.bind(this)
    this.selectLocation = this.selectLocation.bind(this)
    this.updateDimensions = this.updateDimensions.bind(this)

  }
  componentDidMount(){
    document.getElementById('background').addEventListener('scroll', this.handleScroll);
  }
  handleFormSubmit = (event) => {
    event.preventDefault()
  }
  selectAddress= (address) => {
    this.setState({
      address: address
    })
    if(address.cbu && address.cbu.id == 0){
      this.setState({
        outOfAreaModalOpen:true
      })
    }
    else {

      if(address.minimum_order_message && !address.client_host){

        this.setState({
          mimimumModalOpen:true
        })
      }
      else if(address.travel_fee && !this.props.showOnlyWork){
        this.setState({
          travelFeeModalOpen:true
        })
      }
      else{
       if (typeof this.props.selectLocation === 'function') {
         this.props.selectLocation(address)
       }
     }
   }
  }
  confirmMinimum(){
    if (typeof this.props.selectLocation === 'function') {
      this.props.selectLocation(this.state.address)
    }
    this.setState({
      travelFeeModalOpen: false
    })
  }
  handleScroll = (event) => {
    var element = document.getElementById('background')
    if (element.scrollHeight - element.scrollTop === element.clientHeight) {

    }
  };
  componentWillReceiveProps(nextProps) {

    this.setState({
      addresses: nextProps.addresses,
      currentLocation: nextProps.currentLocation
    });
    if(nextProps.addresses && nextProps.addresses.addresses && nextProps.addresses.addresses.length < 1 ){
      this.setState({
        modalIsOpen: true
      })
    }
    this.setState({
      address: nextProps.currentLocation
    })

  }
  updateDimensions() {
      this.setState({width: document.body.clientWidth});
  }
  componentWillUnmount() {
      window.removeEventListener("resize", this.updateDimensions);
  }
  componentDidMount() {
    window.addEventListener("resize", this.updateDimensions);
    this.reloadAddresses()
  }
  reloadAddresses(){
    console.log("Reloading addresses")
    this.ApptService.addresses()
    .then(res =>{
      if(!res){
        //this.props.setError("Error retrieving locations")
        throw new Error('Error fetching addresses, response is invalid: ' + res);
      }
      const addresses = res.addresses
      var this_2 = this
      if(addresses){
        var addressesHTML = []
        this.setState({
          addressesHTML: []
        })
        var i = 0
        addresses.forEach(function(address) {
          addressesHTML.push(<div key={address.id}><LocationEdit location={address} setError={this_2.setError} reloadAddresses ={this_2.reloadAddresses}/><br></br></div>)
          i++;
        });
      }
      this.setState({
        addresses: addresses,
        addressesHTML: addressesHTML
      }, () => {
        this.forceUpdate()

      })
    })
    .catch((err) => {
      throw new Error('Error fetching addresses: ' + err.message);
    });
  }
  openModal() {
    this.setState({modalIsOpen: true});
  }
  closeModal() {
    this.setState({modalIsOpen: false});
    this.ApptService.addresses()
    .then(res =>{
      const addresses = res
      this.setState({
        addresses: addresses,
        showAtWork: false,
        showForm: false,
        showBuildings: false,
        showButton: false
      });
      this.forceUpdate()
      //  this.props.history.replace('/');
    })
    .catch(err =>{
        throw new Error('Error fetching addresses on modal close: ' + err.message);
    })
  }
  closeOutOfAreaModal = () => {
    this.setState({
      outOfAreaModalOpen:false
    })
  }
  handleChildClick(buildings, showForm, showAtWork, mapAddress) {
    this.setState({
      showAtWork: false,
      showForm:false,
      showButton: false
    });
    this.setState({
      showAtWork: showAtWork,
      showForm: showForm,
      buildings: buildings,
      mapAddress: mapAddress
    });

  }
  newLocationClick() {
    this.setState({
      showAtWork: false,
      showForm: true,
      showBuildings: false
    });
  }
  saveBuildings(buildings){
    this.setState({
      showBuildings: true,
      showAtWork: false,
      showForm: false,
      specificBuildings: buildings
    })
  }
  showForm(){
    this.setState({
      showForm: true,
      showAtWork: false,
      showBuildings: false
    })
  }
  selectLocation(address){
    this.reloadAddresses()
  }
  setError(errorMessage){
    this.setState({
      open: true,
      errorMessage: errorMessage,
    })
  }

  render() {
    const padding = 0; // adjust this to your needs
    let height = (this.state.contentHeight + padding);
    let heightPx = height + 'px';
    let heightOffset = height / 2;
    let offsetPx = heightOffset + 'px';

    const customStyle = {
      content: {
        backgroundColor: '#253D59',
        top                   : '0%',
        left                  : '0%',
        height                : '100%',
        width                 : '100%',
      }
    }
     const minimumStyle =
       this.state.width < 780 ?
       {
         content: {
           top                   : '40%',
           left                  : '0%',
           height                : '30%',
           width                 : '100%',
           padding               : '10px',
           right                 : 'auto',
           backgroundColor       : '#253D59',
           color                 : 'white',
         }
       }:
         {
           content: {
             top                   : '40%',
             left                  : '30%',
             height                : '30%',
             width                 : '40%',
             padding               : '10px',
             right                 : 'auto',
             backgroundColor       : '#253D59',
             color                 : 'white',
           }
         }
    const inputProps = {
      value: this.state.address,
      onChange: this.onChange,
    }
    return (
        <div className="locationsList">
          <h3 className="dashboardHeader">Locations<img className="addIcon" src={CirclePlus} onClick={this.openModal}></img></h3>
          <ul className="locationsUL list-group list-group-flush align-content-center">
            {this.state.addressesHTML}
          </ul>
          <Modal
            style={customStyle}
            isOpen={this.state.modalIsOpen}
            contentLabel="Example Modal">
            <MapWithASearchBox onClick = {this.handleChildClick}/>
             {this.state.showAtWork ? <SelectRSL key = {1} saveBuildings = {this.saveBuildings} showForm={this.showForm} buildings={this.state.buildings}/>:null}
             {this.state.showForm ? <LocationForm key = {1} selectLocation={this.selectLocation} closeModal={this.closeModal} address={this.state.mapAddress} setError = {this.props.setError}/>: null}
            {this.state.showBuildings ? <SelectBuildings key = {1}  selectLocation={this.selectLocation}  closeModal={this.closeModal} showForm={this.showForm} buildings={this.state.specificBuildings}/>: null}
             {this.state.showButton ? <button id="newLocation" onClick = {this.newLocationClick}>Enter New Location</button>: null }
             <button onClick = {() => this.closeModal()}className="btn btn-block text-center redButton">Cancel</button>
          </Modal>
          {(this.state.errorMessage && this.state.errorMessage.length) &&
            <ErrorSnackBar color = {this.state.color} open={this.state.open} message = {this.state.errorMessage}/>
          }
        </div>
    )
  }
}
export default Locations



// WEBPACK FOOTER //
// ./src/Components/Locations.js